import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.BACKEND_URL }),
  tagTypes: ["Profile"],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => {
        return { url: `auth/login`, method: "POST", body };
      },
    }),
    logout: builder.mutation({
      query: () => {
        const token = localStorage.getItem("access_token");
        return {
          url: `auth/logout`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
    }),
    refreshToken: builder.query({
      query: () => {
        const token = localStorage.getItem("refresh_token");
        return {
          url: `auth/refresh`,
          method: "GET",
          params: { refresh_token: token },
        };
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
} = authApi;
